import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';
import { RequestStatusId } from '@/types/request';

export default {
  namespaced: true,
  state: {
    statuses: [],
    selectedStatuses: [],
  },
  mutations: {
    set(state: any, payload: any) {
      state.statuses = payload;
    },
    setSelected(state: any, payload: RequestStatusId[]) {
      state.selectedLeaveTypes = payload;
    },
    show(state: any, payload: boolean) {
      state.showModal = payload;
    },
  },
  actions: {
    reset({ commit }: {commit: any}): void {
      commit('set', []);
    },
    update({ commit }: {commit: any}): void {
      request('get', `statuses` )
      .then((response: AxiosResponse) => {
        commit('set', response.data);
      });
    },
  },
  getters: {
    list: (state: any): object[] => state.statuses || [],
    selected: (state: any): RequestStatusId[] => state.selectedRequestStatuses,
  },
};

